module.exports = __webpack_public_path__ + "static/media/img_37.8acbe924.png";